// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2LCQm","resendInfoText":"OnGoingPaymentBox_resendInfoText__221xL"};